import styled from 'styled-components'

export const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'] as const

type Breakpoint = (typeof breakpoints)[number]

export const BreakpointRange = {
  xs: { max: 575 },
  sm: { min: 576, max: 767 },
  md: { min: 768, max: 1279 },
  lg: { min: 1280, max: 1399 },
  xl: { min: 1400 }
} satisfies Record<
  Breakpoint,
  { min: number } | { min: number; max: number } | { max: number }
>

export const GridContainer = styled.div`
  padding: 0 1rem;

  @media (min-width: ${BreakpointRange.lg.min}) {
    padding: 0 1.5rem;
  }

  @media (min-width: ${BreakpointRange.xl.min}) {
    padding: 0 2rem;
  }
`
